import { generatePdf } from "./api-PdfDownload";
import { PdfDownloadButton } from "./PdfDownloadButton";

export default PdfDownloadButton;
export { generatePdf };
